import React from "react";
import Dashboard from "./Overview/Dashboard";
import { MenuDrawer } from "./Menu/MenuDrawer";
import { ChatView } from "./Chat/ChatView";
import { combineProps } from "../../../helpers/objectHelper";
import IncommingCallDialog from "../../shared/IncommingCallDialog";
import { VideoFrame } from "../components/Video/VideoFrame";
import NotificationSnackbar from "./Chat/NotificationSnackbar";
import { Settings } from "./Settings/Settings";
import { ConnectionStatus } from "../../../digitalArena/components/fallbacks/ConnectionStatus";

export const Layout = (props) => {
  const { isCalling, callId, connected, children, orderList, videoRequestResponse } = props;
  return (
    <div>
      <MenuDrawer {...props}>
        {isCalling && connected ? (
          <IncommingCallDialog
            {...combineProps([
              props,
              {
                target: orderList.find((eh) => eh.badgeNo == isCalling),
                deny: () => {
                  videoRequestResponse(false, isCalling, callId);
                },
                accept: () => videoRequestResponse(true, isCalling, callId),
              },
            ])}
          />
        ) : null}
        <ConnectionStatus {...props} />
        <NotificationSnackbar {...props} />
        <VideoFrame {...props} />
        <View {...props} />
      </MenuDrawer>
    </div>
  );
};
const View =(props) => {
  const { page } = props;
  switch (page) {
    case "DASHBOARD":
      return <Dashboard {...props} />;
    case "CHAT":
      return <ChatView {...props} />;
    case "SETTINGS.BOOTH":
    case "SETTINGS.PROFILE":
    case "SETTINGS.ATTACHMENTS":
      return <Settings {...props} />;
    default:
      return null;
  }
}